




















import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import richText from '@/components/RichText/RichText.vue'
import wikiBreadcrumbs from '@/components/wiki/breadcrumbs.vue'
import User from '@/models/Users/User'
import {USER_ROLE_WIKI} from '@/constants'
export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    infoRowsBlock,
    richText,
    wikiBreadcrumbs
  },
  computed: {
    user (): User | false {
      return this.$store.state.user.user
    },
    hasActionsPerm (): boolean {
      if (this.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_WIKI)
      } else {
        return false;
      }
    }
  },
})
